import { CSSObject } from '@chakra-ui/react';
import { EGreenIDStatus } from '../../VerifyIdentity/Services/Config.VerifyIdentity';

export type TStatusProps = {
  status?: EGreenIDStatus;
};

export const ButtonVerified = ({ status }: TStatusProps): CSSObject => ({
  border: 'none',
  borderRadius: 'base',
  fontSize: '2xs',
  fontWeight: '700',
  fontFamily: 'roboto',
  h: '5',
  pl: '0.5',
  pr: '1.5',
  py: '2',
  mb: '1',
  textTransform: 'uppercase',
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  color: () => {
    switch (status) {
      case EGreenIDStatus.VERIFIED:
      case EGreenIDStatus.VERIFIED_ADMIN:
      case EGreenIDStatus.VERIFIED_WITH_CHANGES:
        return 'alpha.900';
      case EGreenIDStatus.PENDING:
        return 'orange.900';
      default:
        return 'white';
    }
  },
  bg: () => {
    switch (status) {
      case EGreenIDStatus.VERIFIED:
      case EGreenIDStatus.VERIFIED_ADMIN:
      case EGreenIDStatus.VERIFIED_WITH_CHANGES:
        return 'alpha.200';
      case EGreenIDStatus.PENDING:
        return 'orange.400';
      default:
        return 'red.500';
    }
  },
  _hover: {
    bg: 'alpha.200',
    color: 'alpha.900',
    border: 'none',
  },
  _disabled: {
    border: 'none',
    boxShadow: 'none',
    bgGradient: 'none',
    fontFamily: 'roboto',
    cursor: 'default',
    opacity: '1',
    color: 'blackAlpha.700',
    bg: 'alpha.200',
    '&&:hover': {
      bg: 'alpha.200',
      color: 'alpha.900',
      border: 'none',
    },
    _after: { opacity: 0 },
  },
  '.chakra-button__icon': {
    ml: '1',
  },
  '.chakra-icon': {
    boxSize: '3',
    bg: 'blackAlpha.700',
    borderRadius: 'full',
    color: () => {
      switch (status) {
        case EGreenIDStatus.VERIFIED:
        case EGreenIDStatus.VERIFIED_ADMIN:
        case EGreenIDStatus.VERIFIED_WITH_CHANGES:
          return 'alpha.200';
        default:
          return 'white';
      }
    },
    m: '1px',
    p: '1px',
    boxShadow: '0px 1px 0px rgba(255, 255, 255, 0.50)',
  },
});
export const BoxOverviewTitle: CSSObject = {
  color: 'white',
  fontSize: 'xl',
  fontFamily: 'accent',
  pb: '2',
  pl: '1',
};
